import { useNotifications } from '@repo/notifications/use-notifications'

const eventUploadsProcessed = {
  social: {
    feedRequest: {
      uploadsProcessed: {},
    },
  },
}

const eventUploadProcessed = (uploadId: string) => {
  return {
    social: {
      feedRequest: {
        uploadProcessed: {
          uploadId: uploadId,
        },
      },
    },
  }
}

export function useNotificationOnUploadsProcessed() {
  const { notification } = useNotifications({
    event: eventUploadsProcessed,
  })

  return { notification }
}

export function useNotificationOnUploadProcessed(uploadId: string) {
  const { notification } = useNotifications({
    event: eventUploadProcessed(uploadId),
  })

  return { notification }
}
